import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <div className="bg-midnight-900" data-id="element-1">
      <Section className="space-y-12" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-3">
          {/* YES */}
          <div className="card-glass p-8 border-l-4 border-l-accent-blue" data-id="element-4">
            <h3 className="text-2xl font-display font-bold text-accent-blue mb-6 flex items-center gap-3 tracking-wide" data-id="element-5">
              <Check className="w-6 h-6" data-id="element-6" />
              Esto es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-7">
              {["Te duermes 'bien' y aun así despiertas entre 2–4AM", 'Sientes ansiedad, taquicardia o calor repentino', 'Te da miedo mirar el reloj porque sabes lo que viene', 'No quieres vivir dependiendo de pastillas', 'Necesitas una guía simple y aplicable esta noche'].map((item, i) => <li key={i} className="flex items-start gap-3 text-white" data-id="element-8">
                  <div className="w-1.5 h-1.5 rounded-full bg-accent-blue mt-2.5 shrink-0" data-id="element-9" />
                  <span data-id="element-10">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NO */}
          <div className="bg-[rgba(255,255,255,0.02)] border border-[rgba(255,255,255,0.05)] rounded-[16px] p-8" data-id="element-11">
            <h3 className="text-2xl font-display font-bold text-slate-400/60 mb-6 flex items-center gap-3 opacity-80 tracking-wide" data-id="element-12">
              <X className="w-6 h-6" data-id="element-13" />
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-14">
              {['Buscas diagnóstico médico o tratamiento clínico', 'Esperas dormir perfecto en 48 horas (es un proceso)', 'No estás dispuesta a seguir un plan de 14 noches', "Buscas una 'píldora mágica' sin cambiar hábitos"].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-400/50" data-id="element-15">
                  <div className="w-1.5 h-1.5 rounded-full bg-slate-400/30 mt-2.5 shrink-0" data-id="element-16" />
                  <span data-id="element-17">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </Section>
    </div>;
}